/* MM «Vis flere» for kolleksjoner (Makeup Mekka). Henter neste side med Section Rendering API og legger
   produktkortene til under de eksisterende. Blurbs/promo-kort fra senere sider tas ikke med.
   Husker hvor mange sider som var lastet, slik at tilbake-knappen fra et produkt gir samme liste og scroll. */
(() => {
  if (customElements.get('mm-load-more')) return;
  const KEY = 'mmLoadMore:';
  const navType = (performance.getEntriesByType('navigation')[0] || {}).type;

  class MmLoadMore extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-mm-load-more-button]');
      this.list = document.getElementById(this.dataset.listId);
      this.startPage = parseInt(this.dataset.page, 10) || 1;
      this.page = this.startPage;
      this.nextUrl = this.dataset.nextUrl || '';
      this.button?.addEventListener('click', () => this.loadMore(true));
      this.restore();
    }

    storageKey() { return KEY + location.pathname + location.search; }

    save(extra = {}) {
      try {
        const prev = JSON.parse(sessionStorage.getItem(this.storageKey()) || '{}');
        sessionStorage.setItem(this.storageKey(), JSON.stringify({ ...prev, page: this.page, ...extra }));
      } catch (e) {}
    }

    async restore() {
      let state = null;
      try { state = JSON.parse(sessionStorage.getItem(this.storageKey()) || 'null'); } catch (e) {}
      if (!state || navType !== 'back_forward' || !(state.page > this.page)) {
        if (state && navType !== 'back_forward') try { sessionStorage.removeItem(this.storageKey()); } catch (e) {}
        this.trackLeave();
        return;
      }
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      while (this.page < state.page && this.nextUrl) {
        if (!(await this.loadMore(false))) break;
      }
      if (typeof state.scrollY === 'number') window.scrollTo(0, state.scrollY);
      this.trackLeave();
    }

    trackLeave() {
      if (this._leaveBound) return;
      this._leaveBound = true;
      window.addEventListener('pagehide', () => { if (this.page > this.startPage) this.save({ scrollY: window.scrollY }); });
    }

    async loadMore(userClick) {
      if (!this.nextUrl || !this.list || this.loading) return false;
      this.loading = true;
      this.button?.setAttribute('aria-busy', 'true');
      try {
        const url = new URL(this.nextUrl, location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);
        const res = await fetch(url.toString(), { credentials: 'same-origin' });
        if (!res.ok) throw new Error(res.status);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const newList = doc.getElementById(this.dataset.listId);
        const newMore = doc.querySelector('mm-load-more');
        if (!newList || !newMore) throw new Error('mangler markup');

        const frag = document.createDocumentFragment();
        newList.querySelectorAll(':scope > product-card').forEach((card) => {
          card.removeAttribute('reveal-on-scroll');
          frag.appendChild(document.importNode(card, true));
        });
        this.list.appendChild(frag);

        this.page = parseInt(newMore.dataset.page, 10) || this.page + 1;
        this.nextUrl = newMore.dataset.nextUrl || '';
        this.update(parseInt(newMore.dataset.shown, 10), parseInt(newMore.dataset.total, 10));
        this.save();
        if (userClick) this.track();
        return true;
      } catch (e) {
        // Reserve: gå til neste side på vanlig måte
        if (userClick && this.nextUrl) location.href = this.nextUrl;
        return false;
      } finally {
        this.loading = false;
        this.button?.removeAttribute('aria-busy');
      }
    }

    update(shown, total) {
      const text = (this.dataset.textSeen || '').replace('[x]', shown).replace('[y]', total);
      const count = this.querySelector('.mm-load-more__count');
      if (count) count.textContent = text;
      const fill = this.querySelector('.mm-load-more__fill');
      if (fill && total) fill.style.width = Math.min(100, (shown / total) * 100) + '%';
      if (!this.nextUrl && this.button) this.button.remove();
    }

    track() {
      const params = { collection_handle: this.dataset.collection, page_number: this.page };
      try {
        if (typeof window.gtag === 'function') window.gtag('event', 'mm_load_more', params);
        else (window.dataLayer = window.dataLayer || []).push({ event: 'mm_load_more', ...params });
      } catch (e) {}
    }
  }

  customElements.define('mm-load-more', MmLoadMore);
})();
